import { useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import { useContext } from "react";
import getConfig from 'next/config';
import { GET_TRENDING_RECOMMENDATIONS, TrendingRecommendationResponse } from "../../graphql/queries/trendingRecommendations";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

const useTrendingSearches = () => {
    const router = useRouter();
    const { main_domain } = useContext(ConfigStateContext);

    // Get query parameters - similar to how SEO hook works
    const getQueryParams = () => {
        const { countryCode } = getConfig().publicRuntimeConfig;
        
        // Don't execute if we don't have router path
        if (!router.asPath) {
            return null;
        }

        // Construct the full URL using main_domain and router path
        const sourceUrl = `https://${main_domain}${router.asPath}`;

        return {
            sourceUrl,
            countryCode
        };
    };

    const queryParams = getQueryParams();

    const { data, loading, error } = useQuery<TrendingRecommendationResponse>(GET_TRENDING_RECOMMENDATIONS, {
        variables: queryParams || {},
        skip: !queryParams,
        fetchPolicy: "cache-first",
        errorPolicy: "all" // Continue even if there are GraphQL errors
    });

    return {
        loading,
        data: data?.getTrendingRecommendations,
        error,
        hasRecommendations: !!(data?.getTrendingRecommendations?.candidates?.length)
    };
};

export { useTrendingSearches };
